import { render, staticRenderFns } from "./LinkedResource.vue?vue&type=template&id=18e72a2a&"
import script from "./LinkedResource.vue?vue&type=script&lang=js&"
export * from "./LinkedResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports